/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessParty } from '../../models/business-party';

export interface ByBpGuids$Params {
      body: Array<string>
}

export function byBpGuids(http: HttpClient, rootUrl: string, params: ByBpGuids$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BusinessParty>>> {
  const rb = new RequestBuilder(rootUrl, byBpGuids.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BusinessParty>>;
    })
  );
}

byBpGuids.PATH = '/business-parties';
